import { PermissionEnum } from '../../../common/permissions/permissions.Enum';
import { getGroupPermissionFactory } from '../../../common/permissions/permissions.utils';
import { getUserManagementModuleName } from './user-management.permissions';

export class SystemRolesPermissions {
    static GroupName = `${getUserManagementModuleName()}.SystemRoles`;

    static getPermissions = getGroupPermissionFactory(SystemRolesPermissions.GroupName);

    static Permissions = {
        ReadAll: SystemRolesPermissions.getPermissions(PermissionEnum.READ_ALL)
    };
}
